import { observer } from 'mobx-react-lite';
import { useState } from 'react';

import { type LBIcon } from '@/assets/icons/icons';
import { renderPaperChild } from '@/features/artifacts';
import { cn } from '@/lib/utils';

import { type SpriteArtifact } from './use-sprite-artifact';

interface SpritePaperThumbProps {
  artifact: SpriteArtifact;
  fallbackIcon: LBIcon;
  fallbackLabel?: string;
  iconClassName?: string;
}

export const SpritePaperThumb = observer(
  ({
    artifact,
    fallbackIcon: FallbackIcon,
    fallbackLabel,
    iconClassName,
  }: SpritePaperThumbProps) => {
    const { display } = artifact;
    const [brokenSrc, setBrokenSrc] = useState<string>();

    const fallback = (
      <div className="absolute inset-0 flex flex-col items-center justify-center gap-1.5">
        <FallbackIcon
          strokeWidth={1.25}
          className={cn('size-6 text-foreground-muted', iconClassName)}
        />
        {fallbackLabel && (
          <span className="text-xs text-foreground-muted">{fallbackLabel}</span>
        )}
      </div>
    );

    return (
      <div
        ref={artifact.ref}
        aria-hidden
        inert
        className="relative size-full overflow-hidden"
      >
        {display.kind === 'thumbnail' && display.src !== brokenSrc ? (
          <>
            {fallback}
            <img
              src={display.src}
              alt=""
              draggable={false}
              onError={() => setBrokenSrc(display.src)}
              className="absolute inset-0 size-full object-cover object-top"
            />
          </>
        ) : display.kind === 'image' ? (
          renderPaperChild('image', display.content)
        ) : (
          fallback
        )}
      </div>
    );
  }
);
